import { css } from '@emotion/css';
import { colors } from 'constants/theme';
const bgTitleLinear = `#002287`;

const promotionPageStyles = {
    wrap: css`
        background: #f2f2f2;
        min-height: 50vh;
    `,
    header: css`
        display: flex;
        align-items: center;
        gap: 16px;
        padding: 30px 10px;
    `,
    title: css`
        display: flex;
        align-items: center;
        gap: 10px;
        img {
            width: 36px;
        }
        h6 {
            font-size: 18px;
        }
    `,
    tabList: css`
        flex: 1;
        display: flex;
        list-style-type: none;
        background: ${bgTitleLinear};
        gap: 10px;
        border-radius: 10px;
        padding: 10px 16px;
    `,
    tabItem: css`
        padding: 12px;

        text-align: center;
        color: ${colors.white};
        text-transform: uppercase;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        /* &::before {
            content: '';
            position: absolute;
            top: 4px;
            left: 0;
            width: 100%;
            height: calc(100% - 4px);
            background: #f2f2f2;
            border-radius: 8px 8px 0 0;
            opacity: 0;
            pointer-events: none;
            z-index: 0;
        } */
        &.active, &:hover {
            background: ${colors.white};
            border-radius: 5px;
            span {
                color: ${bgTitleLinear};
            }
            &::before {
                opacity: 1;
            }
        }
        span {
            position: relative;
            z-index: 1;
            font-weight: 500;
        }
    `,
    promoContent: css`
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 16px;
    `,
    promoItem: css`
        flex: 0 0 calc(100% / 3);
        max-width: calc(100% / 3);
        padding: 12px;
        img {
            max-height: 184px;
        }
    `,
    promoItemInner: css`
        background: ${colors.white};
        border-radius: 8px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        height: 100%;
        cursor: pointer;
        &:hover {
            img {
                transform: scale(1.05);
            }
        }
        img {
            width: 100%;
            transition: 0.25s;
        }
        p {
            flex: 1;
            padding: 8px;
            font-size: 14px;
        }
    `,
    noPromo: css`
        padding: 60px 0;
        text-align: center;
        margin: 0 auto;
    `,
};
export default promotionPageStyles;
